<template>
  <div class="main-content" autocomplete="off">
    <div>
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            Clients
            <!-- <small v-if="userIsAdmin" class="add-new">
              <a v-b-modal.modal-add-client>
                <i class="nav-icon i-Add"></i>
                <span class="item-name"> Add Client</span>
              </a>
            </small> -->
          </h2>
        </b-col>
        <b-col md="4">
          <b-form-input
            v-model="searchWord"
            class="form-control-rounded"
            type="text"
            required
            placeholder="Search..."
          ></b-form-input>
        </b-col>
      </b-row>
      <!-- <b-row v-if="loading">
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
        <b-col md="4">
          <loadingSkeleton />
        </b-col>
      </b-row> -->
      <div v-show="!loading" v-if="constructing">
        <b-table
          class="custom-table"
          striped
          th-class="cursor-pointer"
          hover
          bordered
          responsive
          :items="filteredClients"
          :fields="fields"
        >
          <template v-slot:cell(actions)="row">
            <div class="actions">
              <b-button
                v-if="userIsAdmin"
                size="sm"
                variant="success"
                @click="editClientTrigger(row.item.name)"
              >
                Edit
              </b-button>
              <b-button
                v-if="userIsSuperAdmin"
                size="sm"
                variant="danger"
                @click="deleteClientTrigger(row.item.name)"
              >
                Delete
              </b-button>
            </div>
          </template>
        </b-table>

        <!-- <transition-group name="fade" tag="b-row"> -->
        <!-- <b-col v-for="client in filteredClients" :key="client.id" md="6" lg="4">
          <ClientBlock
            :client="client"
            @editClient="editClientTrigger"
            @deleteClient="deleteClientTrigger"
          />
        </b-col> -->
        <!-- </transition-group> -->
      </div>
    </div>
    <b-modal
      id="modal-edit-client"
      ref="modalUpdateClient"
      centered
      :hide-footer="true"
      :hide-header="true"
      size="lg"
    >
      <div class="modal-addition-only">
        <b-form-input
          v-model="existingClient.client.name"
          class="form-control-rounded input-extra-large"
          type="text"
          required
          placeholder="Enter client name..."
          @keyup.enter="updateClient()"
        ></b-form-input>
        <!-- <vue-tags-input
          id="projectsInput"
          v-model="projectName"
          class=" text-14 tag-custom"
          :tags="existingClient.projects.map(x => x.name)"
          :autocomplete-items="filteredProjects.map(x => x.name)"
          placeholder="Optional client projects..."
          @tags-changed="newRoles => updateExistingClientProjects(newRoles)"
        /> -->
        <b-button
          pill
          variant="success ripple col-md-2"
          class="save-btn"
          @click="updateClient()"
          >Save</b-button
        >
      </div>
    </b-modal>
    <b-modal
      id="modal-add-client"
      centered
      :hide-footer="true"
      :hide-header="true"
      size="lg"
    >
      <div class="modal-addition-only">
        <ApolloMutation
          :mutation="require('@/graphql/Client/AddClient.gql')"
          :variables="{
            client: {
              name: newClientName
            }
          }"
          @done="addedSuccess"
        >
          <template v-slot="{ mutate }">
            <b-form-input
              v-model="newClientName"
              class="form-control-rounded input-extra-large"
              type="text"
              required
              placeholder="Enter client name..."
              @keyup.enter="addClient(mutate)"
            ></b-form-input>
            <!-- <vue-tags-input
          id="projectsInput"
          v-model="projectName"
          class=" text-14 tag-custom"
          :tags="clientProjects.map(x => x.name)"
          :autocomplete-items="filteredProjects.map(x => x.name)"
          placeholder="Optional client projects..."
          @tags-changed="newRoles => updateClientProjects(newRoles)"
        /> -->
            <b-button
              pill
              variant="success ripple col-md-2"
              class="save-btn"
              @click="addClient(mutate)"
              >Save</b-button
            >
          </template>
        </ApolloMutation>
      </div>
    </b-modal>
    <b-modal
      ref="modalDeleteClient"
      centered
      :hide-footer="true"
      :hide-header="true"
      size="lg"
    >
      <div class="modal-addition-only">
        <b-form-input
          readonly
          class="dark-placeholder form-control-rounded input-extra-large"
          type="text"
          :placeholder="
            `Are you sure you want to delete Client: ${deleteClient.name}?`
          "
        ></b-form-input>
        <ApolloMutation
          :mutation="require('@/graphql/Client/DeleteClient.gql')"
          :variables="{
            client: {
              id: deleteClient.id
            }
          }"
          @done="deletedSuccess"
        >
          <template v-slot="{ mutate }">
            <div class="modal-flex">
              <b-button
                class="col-md-2 "
                variant="success ripple"
                @click="$refs.modalDeleteClient.hide()"
              >
                Cancel
              </b-button>
              <b-button
                variant="danger ripple"
                class="col-md-2 delete-modal-btn"
                @click="mutate()"
              >
                Confirm
              </b-button>
            </div>
          </template>
        </ApolloMutation>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
// import loadingSkeleton from "@/components/projectblock/loadSkeleton"
export default {
  name: "ManageClients",
  components: {
    // loadingSkeleton
  },
  apollo: {
    clients: {
      query: require("@/graphql/Client/GetClients.gql")
      // subscribeToMore: [
      //   {
      //     document: require("@/graphql/Client/ClientAdded.gql"),
      //     updateQuery: (previousResult, { subscriptionData }) => {
      //       previousResult.clients.push(subscriptionData.data.clientAdded)
      //       return previousResult.clients
      //     }
      //   }
      // ]
    }
  },
  data() {
    return {
      loading: true,
      constructing: false,
      newClientName: "",
      clientProjects: [],
      projectName: "",
      searchWord: "",
      existingClient: { client: {}, projects: [] },
      deleteClient: {},
      fields: []
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "getCurrentUser"
    }),
    userIsAdmin() {
      return (
        this.currentUser?.roles?.includes("Admin") ||
        this.currentUser?.roles?.includes("Super Admin")
      )
    },
    userIsSuperAdmin() {
      return this.currentUser?.roles?.includes("Super Admin")
    },
    filteredClients() {
      return this.clients
        ?.map(x => {
          return { name: x.name }
        })
        .filter(x => x.name.includesLowerCase(this.searchWord))
    }
  },
  created() {
    this.fields = [{ key: "name", sortable: true }, { key: "Actions" }]
  },
  mounted() {
    setTimeout(() => {
      this.constructing = true
      this.$nextTick(() => {
        this.loading = false
      })
    }, 500)
  },
  methods: {
    // ...mapActions({
    //   addClientToDb: "clients/addClient",
    //   linkProjectsToClient: "projects/linkProjectsToClient",
    //   unLinkProjectsFromClient: "projects/unLinkProjectsFromClient",
    //   updateDbClient: "clients/updateClient",
    //   removeClient: "clients/removeClient"
    // }),
    /**
     * Updates client
     * @param client
     * @returns {*|boolean}
     */
    updateSubscription(client) {
      return (
        this.clients.find(x => x.id == client.id) &&
        !this.clients.find(x => x.id == client.id)
      )
    },
    /**
     * Deletes client
     * @param client
     * @returns {boolean|*}
     */
    deleteSubscription(client) {
      return (
        !this.clients.find(x => x.id == client.id) &&
        this.clients.find(x => x.id == client.id)
      )
    },
    /**
     * Adds new client
     * @param client
     * @returns {boolean}
     */
    addSubscription(client) {
      return !this.clients.find(x => x.id == client.id)
    },
    /**
     * Validates adding/updating client
     * @param clientName
     * @returns {boolean}
     */
    validateInput(clientName) {
      if (!clientName) {
        this.$toasted.error("Please enter a client name")
        return false
      }
      if (this.clients.find(x => x.name == clientName)) {
        if (!this.existingClient.client.name == clientName) {
          //This is an update and this name already exists
          this.$toasted.error("Client name already exists")
          return false
        }
      }
      return true
    },
    /**
     * Updates client
     * @returns {Promise<void>}
     */
    async updateClient() {
      //Validation
      if (!this.validateInput(this.existingClient.client.name)) return

      await this.$apollo.mutate({
        mutation: require("@/graphql/Client/UpdateClient.gql"),
        variables: {
          client: {
            colour: this.existingClient.client.color,
            name: this.existingClient.client.name,
            id: this.existingClient.client.id
          }
        }
      })

      // await this.linkProjectsToClient({
      //   projects: this.existingClient.projects,
      //   clientId: this.existingClient.client.id
      // })
      // await this.updateDbClient(this.existingClient.client)
      // const projectsToRemove = this.lodash.difference(
      //   this.existingClient.oldProjects,
      //   this.existingClient.projects
      // )
      // if (projectsToRemove.length > 0) {
      //   await this.unLinkProjectsFromClient({
      //     projectIds: projectsToRemove.map(x => x.id)
      //   })
      // }
      this.updatedSuccess()
    },
    /**
     * Adds client
     * @param mutate
     * @returns {Promise<void>}
     */
    async addClient(mutate) {
      //Validation
      if (!this.validateInput(this.newClientName)) return
      //Add client to db
      mutate()
    },
    /**
     * Informs user client was added and clears form
     */
    addedSuccess() {
      this.$toasted.success("Client added successfully")
      this.newClientName = ""
      this.clientProjects = []
    },
    /**
     * Informs user client was updated and clears form
     */
    updatedSuccess() {
      this.$toasted.success("Client updated successfully")
      this.existingClient = { client: {}, projects: [], oldProjects: [] }
      this.$refs.modalUpdateClient.hide()
    },
    /**
     * Informs user client was deleted and removes client from data
     */
    deletedSuccess() {
      this.$toasted.success("Client removed successfully")
      //Remove client from clients list
      this.lodash.remove(this.clients, client => {
        return client.id === this.deleteClient.id
      })
      this.clients = this.clients.map(x => x) //Needed to update the table's state
      this.$refs.modalDeleteClient.hide()
      //Done to not show 'undefined' in modal while closing
      setTimeout(() => {
        this.deleteClient = {}
      }, 1000)
    },
    /**
     * Sets existing client and opens modal
     * @param clientName
     */
    editClientTrigger(clientName) {
      this.existingClient.client = this.clients.find(x => x.name == clientName)
      this.$refs.modalUpdateClient.show()
    },
    updateClientProjects(newRoles) {
      this.clientProjects = this.getFilteredProjects(newRoles)
    },
    updateExistingClientProjects(newRoles) {
      this.existingClient.projects = this.lodash.union(
        this.existingClient.projects.filter(x =>
          newRoles.find(t => t.text == x.name)
        ),
        this.getFilteredProjects(newRoles)
      )
    },
    /**
     * Sets deleteClient and opens dialog
     * @param clientName
     */
    deleteClientTrigger(clientName) {
      this.deleteClient = this.clients.find(x => x.name == clientName)
      this.$dialog({
        title: `Delete: ${this.deleteClient.name}`,
        content: "You're about to delete this Client",
        btns: [
          {
            label: "Go ahead",
            color: "#3f51b5",
            callback: () => {
              this.$apollo
                .mutate({
                  mutation: require("@/graphql/Client/DeleteClient.gql"),
                  variables: {
                    client: {
                      id: this.deleteClient.id
                    }
                  }
                })
                .then(() => {
                  this.deletedSuccess()
                })
            }
          },
          {
            label: "Cancel",
            color: "#444",
            ghost: true
          }
        ]
      })
      // this.$refs.modalDeleteClient.show()
    },
    /**
     * Gets projects without clients
     * @param newRoles
     * @returns {*}
     */
    getFilteredProjects(newRoles) {
      return this.projectsWithoutClient
        .filter(p => newRoles.map(x => x.text).includes(p.name))
        .map(x => ({ id: x.id, name: x.name }))
    }
    // removeAutocomplete() {
    //   setTimeout(() => {
    //     const el = document.querySelector("input")
    //     el.setAttribute("autocomplete", "off")
    //   }, 500)
    // }
  }
}
</script>

<style scoped>
.modal-addition-only {
  display: flex;
  flex-direction: column;
}
.modal-body {
  background: white;
}
.modal-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3rem;
}
.delete-modal-btn {
  margin-left: 10%;
}
.modal-addition-only input {
  margin-right: 15px;
}
.add-new:hover {
  cursor: pointer;
}
.vue-tags-input {
  max-width: unset !important;
}

/* .ti-input {
  background: #f8f9fa !important;
  color: #0b192b !important;
  border-radius: 50% !important;
} */
/* .tag-custom {
  background: #f8f9fa !important;
  color: #0b192b !important;
} */

.taginput {
  margin-top: 15px;
  margin-bottom: 15px;
}

.tag-custom {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
div#projectsInput {
  /* background: #f8f9fa !important; */
  color: #0b192b !important;
}

input#projectsInput {
  background: inherit !important;
}
.actions {
  display: flex;
  justify-content: space-between;
}
.save-btn {
  margin-top: 1rem;
}
.dark-placeholder::placeholder {
  color: black;
}
</style>

<style>
div.custom-table > table > thead > tr > th:last-of-type {
  width: 15%;
}
</style>
